<template>
  <FilterRouteBox v-model:title="currentCategoryName" ga-interaction="filter_select" :items="categoryRouteMenus" />
  <CardWrapper>
    <RouterView />
  </CardWrapper>
</template>
<script setup lang="ts">
  import { useMapleGuideStore } from '@/store/MapleGuide'
  import { computed, ref } from 'vue'

  const store = useMapleGuideStore()

  const categoryRouteMenus = computed(() =>
    store.CategoryNames.map((name) => ({
      title: name,
      route: { name: 'maple-guide-list', params: { category: name.toLowerCase() } },
    }))
  )
  const currentCategoryName = ref('all')
</script>
